export enum ReferralComponentLocators {
	referralEditButton = 'referralEditButton',
	referralSaveButton = 'referralSaveButton',
	referralEmailField = 'referralEmailField',
}
